var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{attrs:{"size":"mini","disabled":_vm.disabled_attr,"min":1,"max":10},on:{"keyup":_vm.validate,"change":_vm.updateAantal},model:{value:(_vm.aantal),callback:function ($$v) {_vm.aantal=$$v},expression:"aantal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }